"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated please use `packages/theme/src/novo/novoColorPalette.js`
 */
const colorPalette = {
    colorBlue01: '#00112D',
    colorBlue02: '#00225A',
    colorBlue03: '#003486',
    colorBlue04: '#0045B3',
    colorBlue05: '#0056E0',
    colorBlue06: '#246FE5',
    colorBlue07: '#4687ED',
    colorBlue08: '#99BBF3',
    colorBlue09: '#CCDDF9',
    colorGray01: '#141414',
    colorGray02: '#292929',
    colorGray03: '#3D3D3D',
    colorGray04: '#525252',
    colorGray05: '#666666',
    colorGray06: '#858585',
    colorGray07: '#A3A3A3',
    colorGray08: '#C2C2C2',
    colorGray09: '#E0E0E0',
    colorGray10: '#F1F1F1',
    colorGreen01: '#062715',
    colorGreen02: '#0C4E2A',
    colorGreen03: '#127440',
    colorGreen04: '#189B55',
    colorGreen05: '#1EC26A',
    colorGreen06: '#4BCE88',
    colorGreen07: '#78DAA6',
    colorGreen08: '#A5E7C3',
    colorGreen09: '#D2F3E1',
    colorPurple01: '#171719',
    colorPurple02: '#2F2E32',
    colorRed01: '#29070A',
    colorRed02: '#510E14',
    colorRed03: '#7A141F',
    colorRed04: '#A21B29',
    colorRed05: '#CB2233',
    colorRed06: '#D83848',
    colorRed07: '#F24D5F',
    colorRed08: '#EAA7AD',
    colorRed09: '#F5D3D6',
    colorWhite: '#FFFFFF',
    colorYellow01: '#322305',
    colorYellow02: '#63460A',
    colorYellow03: '#956810',
    colorYellow04: '#C68B15',
    colorYellow05: '#F8AE1A',
    colorYellow06: '#F9BE48',
    colorYellow07: '#FBCE76',
    colorYellow08: '#FCDFA3',
    colorYellow09: '#FEEFD1',
};
exports.default = colorPalette;
